import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SchedaCoopSocialiFormService } from './scheda-coop-sociali-form.service';
import { SchedaCoopSocialiWarningsFormService } from './warnings/scheda-coop-sociali.warnings';

@NgModule({
    declarations: [],
    imports: [CommonModule, ReactiveFormsModule],
    providers: [SchedaCoopSocialiFormService, SchedaCoopSocialiWarningsFormService],
})
export class SchedaCoopSocialiFormModule {}
